export default __webpack_public_path__ + "static/media/Namibia.57fc2ea0.png";